export default __webpack_public_path__ + "static/media/welcomepageimg.91e2a0aa.png";